const translations = {
    de: {
        a_z: 'A bis Z',
        address: 'Adresse',
        add_events: 'Heutige Veranstaltungen hinzufügen',
        add_locations: 'Orte hinzufügen',
        all: 'Alle',
        all_categories: 'Alle Kategorien',
        all_events: 'Alle Veranstaltungen',
        all_locations: 'Alle Orte',
        and_others: 'und weitere...',
        appointment: 'Uhrzeit',
        appointments: 'Uhrzeiten',
        arbitrary: 'Zeitraum wählen',
        assume_selection: 'Auswahl übernehmen',
        back: 'Zurück',
        cancelled: 'Abgesagt',
        categories: 'Kategorien',
        category: 'Kategorie',
        clock: 'Uhr',
        contact: 'Kontakt',
        contact_form: 'Kontaktformular',
        contact_host: 'Veranstalter kontaktieren',
        copyright: '© ' + (new Date()).getFullYear() + ' Dresden Marketing Gesellschaft',
        customers: 'Über 4000+ Kunden vertrauen uns',
        customers_description: 'Was unsere Kunden über uns sagen',
        data_disclaimer_copy: 'Für den neuen Online-Veranstaltungskalender mussten wir große Datenmengen aus dem alten ins neue System übertragen. Aus technischen Gründen können eventuell Daten fehlen oder verschoben sein. Bitte überprüfen Sie Ihre Eintragungen. <a href=\'https://veranstaltungen-api.dresden.de/\' class=\'text-link\' target=\'_blank\'>Loginbereich für Veranstalter</a><br><br>Dieser Hinweis ist nur vorübergehend sichtbar. Sie können sich jederzeit über den Punkt "Veranstalterbereich" im <strong>Menu</strong> einloggen.<br>Danke!',
        data_disclaimer_headline: 'Wichtiger Hinweis',
        date: 'Datum',
        date_info: 'Zeitraum',
        date_range: 'Ich habe einen festen Zeitraum',
        date_range_picker: {
            months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
            weekdaysLong: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
            weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
            labels: {
                nextMonth: 'Nächster Monat',
                previousMonth: 'Letzter Monat',
            },
        },
        day: 'Tag:',
        description: 'Beschreibung',
        discover_more: 'Mehr erfahren',
        dontShow: 'Nicht anzeigen',
        event_dates_cancel_info: 'Informationen zu abgesagten oder verschobenen Veranstaltungen',
        event_location: 'Veranstaltungsort',
        event_multiple_dates_info: 'Diese Veranstaltung hat mehrere Termine. Sie finden alle Termine in der Detailansicht.',
        event_search: 'Veranstaltungssuche',
        event_search_description: 'Entdecken. Erleben. Genießen.',
        events: 'Veranstaltungen',
        events_later: 'Spätere Termine',
        fax: 'Fax:',
        features: 'Eigenschaften',
        find_out_more: 'Mehr erfahren',
        for_free: 'Eintritt frei',
        full_day: 'Ganztägig',
        gallery: 'Galerie',
        highlight: 'Highlight',
        highlights: 'Highlights',
        highlights_description: 'Die beliebtesten Veranstaltungen auf einen Blick',
        home: 'Home',
        homepage: 'Zur Startseite',
        host: 'Veranstalter',
        host_area: 'Veranstalterbereich',
        host_events: 'Veranstaltungen dieses Veranstalters',
        host_location: 'Standort',
        ical_label: 'Termin merken',
        imprint: 'Impressum',
        list_page_title: 'Suchergebnisse',
        loading: 'Lade...',
        loading_events: 'Lade Veranstaltungen...',
        loading_locations: 'Lade Orte...',
        location: 'Veranstaltungsort',
        location_events: 'Veranstaltungen an diesem Ort',
        location_search: 'Adresse',
        locations: 'Orte',
        main_page_title: 'Veranstaltungskalender Dresden\xa0Elbland',
        map_popup: 'Klicken Sie auf die Marker um mehr über das Event zu erfahren.',
        map_popup_locations: 'Klicken Sie auf die Marker um mehr über den Ort zu erfahren.',
        mapbox_consent_dialog: 'Zur Zeit ist das Anzeigen von Karten aufgrund Ihrer Einstellungen deaktiviert. Möchten Sie ' +
            'Ihre Einstellung für die Einbindung von Karten ändern und das Anzeigen von Karten erlauben?',
        navigation: 'Navigation',
        newDate: 'Neuer Termin: ',
        newDateUnknown: 'Neuer Termin unbekannt',
        newest: 'Neuste',
        next_week: 'Nächste Woche',
        no: 'Nein',
        no_future_dates: 'Keine zukünftigen Termine bekannt.',
        no_location_results: ({listingTitle}) => `Es wurden leider keine ${listingTitle || 'Orte'} gefunden.`,
        no_results: 'Es wurden leider keine Veranstaltungen gefunden.',
        oldest: 'Älteste',
        online: 'Online',
        online_event: 'Online-Veranstaltung',
        opening_hours: 'Öffnungszeiten',
        opening_hours_info: 'Bei der Suche nach geöffneten Einrichtungen werden nur die Einrichtungen angezeigt, für die auch\n' +
            'Öffnungszeiten hinterlegt wurden. Sonderöffnungszeiten z. B. in den Ferien oder an Feiertagen sowie\n' +
            'ständig geöffnete Angebote (z. B. Parks und Spielplätze) werden nicht berücksichtigt.',
        others: 'Sonstige',
        page_not_found_copy: 'Wir bitten für die Unannehmlichkeiten um Entschuldigung. Bitte versuchen Sie es später erneut.',
        page_not_found_headline: 'Bitte entschuldigen Sie, die angeforderte Seite wurde nicht gefunden.',
        phone: 'Tel:',
        play: 'Video Abspielen',
        rescheduled: 'Verschoben',
        price: 'Eintrittspreis',
        price_heigh: 'Preis (hoch zu niedrig)',
        price_low: 'Preis (niedrig zu hoch)',
        price_max: 'Maximaler Eintrittspreis: ',
        prices_from: 'ab;',
        privacy: 'Datenschutz',
        read_less: '- weniger lesen',
        read_more: 'Weiterlesen',
        recommendations: 'Unsere Vorschläge für Sie',
        recommendations_description: 'Finden Sie Veranstaltungen basierend auf der Kategorie',
        results: 'Ergebnisse:',
        results_found: 'Veranstaltungen gefunden',
        scrollToTop: 'nach oben scrollen',
        search: 'Suchen',
        search_info: 'Suchbegriff eingeben und/oder Datum auswählen:',
        search_placeholder: 'Suchen',
        search_results_for: 'Suchergebnisse für',
        select_category: 'Kategorie wählen',
        select_weekday: 'Wochentag wählen',
        service: 'Service',
        show_all: 'Alle ansehen',
        show_more_events: 'Mehr Veranstaltungen anzeigen',
        show_more_locations: 'Mehr Orte anzeigen',
        show_playgrounds: 'Spielplätze anzeigen',
        sort_by: 'Sortieren nach',
        special_opening_hours: 'Spezielle Öffnungszeiten',
        starting_at: 'ab',
        tags: 'Schlagwörter',
        terms: 'Nutzungsbedingungen',
        this_weekend: 'Dieses Wochenende',
        ticket_button: 'Tickets',
        time: 'Uhrzeit:',
        tmgsLogoAltText: 'Sachsen. Land von Welt.',
        today: 'Heute',
        tomorrow: 'Morgen',
        undefined: 'Kein Preis vorhanden',
        video: 'Video',
        video_consent_dialog: ({videoProvider}) => `Zur Zeit ist das Abspielen von ${videoProvider}-Videos aufgrund Ihrer ` +
            `Einstellungen deaktiviert. Möchten Sie Ihre Einstellung für ${videoProvider}-Videos ändern und ` +
            'das Abspielen des Videos erlauben?',
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        sunday: 'Sonntag',
        yes: 'Ja',
        z_a: 'Z bis A',
    },
    en: {
        a_z: 'A to Z',
        address: 'Address',
        add_events: 'Add today events',
        add_locations: 'Add locations',
        all: 'All',
        all_categories: 'All categories',
        all_events: 'All events',
        all_locations: 'All locations',
        and_others: 'and others...',
        appointment: 'Appointment',
        appointments: 'Appointments',
        arbitrary: 'Select a date',
        assume_selection: 'assume selection',
        back: 'Back',
        categories: 'Categories',
        category: 'Category',
        cancelled: 'Cancelled',
        clock: ' ', // Leave empty, because the translation clock/o'clock is not useful in our use case
        contact: 'Contact',
        contact_form: 'Contact form',
        contact_host: 'Contact host',
        copyright: '© ' + (new Date()).getFullYear() + ' Dresden Marketing Gesellschaft',
        customers: 'Trusted by over 4000+ customers',
        customers_description: 'What our customers say about us',
        data_disclaimer_copy: 'For the new online event calendar we had to transfer large amounts of data from the old system to the new one. For technical reasons, data may be missing or moved. Please check your entries. <a href=\'https://veranstaltungen-api.dresden.de/\' class=\'text-link\' target=\'_blank\'>Login area for organizers</a><br><br> This notice is only temporarily visible. You can log in at any time by clicking on "Organizer area" in the <strong>Menu</strong>.<br>Thank you!\n',
        data_disclaimer_headline: 'Important note',
        date: 'Date',
        date_info: 'Period',
        date_range: 'I have a fixed period',
        day: 'Day',
        description: 'Description',
        discover_more: 'Find out more',
        dontShow: 'Do not show',
        event_dates_cancel_info: 'Information on cancelled or rescheduled events',
        event_location: 'Event location',
        event_multiple_dates_info: 'This event has multiple dates. You can find all available dates in the detail view.',
        event_search: 'Event search',
        event_search_description: 'Discover. Experience. Enjoy.',
        events: 'Events',
        events_later: 'Other dates',
        fax: 'fax:',
        features: 'Features',
        find_out_more: 'Find out more',
        for_free: 'Free',
        full_day: 'Full day',
        gallery: 'Gallery',
        highlight: 'Highlight',
        highlights: 'Highlights',
        highlights_description: 'The most popular events at a glance',
        home: 'Home',
        homepage: 'To homepage',
        host: 'Host',
        host_area: 'Organizer area',
        host_events: 'Events of this organizer',
        host_location: 'Location',
        ical_label: 'Remember date',
        imprint: 'Imprint',
        list_page_title: 'Search results',
        loading_events: 'Loading events...',
        loading_locations: 'Loading locations...',
        location_events: 'Events at this location',
        location_search: 'Address',
        locations: 'Locations',
        main_page_title: 'Event calendar Dresden\xa0Elbland',
        map_popup: 'Click on the markers to learn more about the event.',
        map_popup_locations: 'Click on the markers to learn more about the location.',
        mapbox_consent_dialog: 'Currently, the display of maps is disabled due to your settings. Do you want to change your ' +
            'map inclusion setting and allow showing maps?',
        navigation: 'Navigation',
        newDate: 'New date: ',
        newDateUnknown: 'New date unknown',
        newest: 'Newest',
        next_week: 'Next week',
        no: 'No',
        no_future_dates: 'No future dates available.',
        no_location_results: 'Unfortunately no locations were found.',
        no_results: 'Unfortunately no events were found.',
        oldest: 'Oldest',
        online: 'Online',
        online_event: 'Online-Event',
        opening_hours: 'Opening hours',
        opening_hours_info: 'When searching for open facilities, only those facilities are displayed for which opening hours have been entered.\n' +
            'opening hours have been entered. Special opening hours, e.g. during holidays or on public holidays, as well as permanent\n' +
            'permanently open facilities (e.g. parks and playgrounds) are not taken into account.',
        others: 'Others',
        page_not_found_copy: 'We apologize for the inconvenience. Please try again later.',
        page_not_found_headline: 'Please excuse us, the requested page was not found.',
        phone: 'tel:',
        play: 'Play video',
        rescheduled: 'Rescheduled',
        price: 'Ticket price',
        price_heigh: 'Price (high to low)',
        price_low: 'Price (low to high)',
        price_max: 'Ticket price max: ',
        prices_from: 'from',
        privacy: 'Privacy policy',
        read_less: '- read less',
        read_more: 'Read more',
        recommendations: 'Our suggestions for you',
        recommendations_description: 'Find events based on the category',
        results: 'Results:',
        results_found: 'Events found',
        scrollToTop: 'scroll to the top',
        search: 'Search',
        search_info: 'Enter search term and/or select date:',
        search_placeholder: 'Search',
        search_results_for: 'Results for',
        select_category: 'Select a category',
        select_weekday: 'select weekday',
        service: 'Service',
        show_all: 'View all',
        show_more_events: 'Show more events',
        show_more_locations: 'Show more locations',
        show_playgrounds: 'Show playgrounds',
        sort_by: 'Sort by',
        special_opening_hours: 'Special opening hours',
        starting_at: 'Starting at',
        tags: 'Keywords',
        terms: 'Terms of use',
        this_weekend: 'This weekend',
        ticket_button: 'Tickets',
        time: 'Time',
        tmgsLogoAltText: 'Saxony. State Of The Arts.',
        today: 'Today',
        tomorrow: 'Tomorrow',
        undefined: 'Price undefined',
        video: 'Video',
        video_consent_dialog: ({videoProvider}) => `Currently, playing ${videoProvider} videos is disabled due ` +
            `to your settings. Do you want to change your setting for ${videoProvider} videos and allow playing the video?`,
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        yes: 'Yes',
        z_a: 'Z to A',
    }
};

export default translations;
